module.exports = __webpack_public_path__ + "static/media/linkedin_learning.8414e436.png";